import { Redirect, Route, Switch } from 'react-router-dom';
import { AdventureRouteSwitch } from '~/components/Adventure/AdventureRouteSwitch';
import { ChallengeRouteSwitch } from '~/components/Challenge/ChallengeRouteSwitch';
import { EmbeddedViewer } from '~/components/Embedded/Viewer/EmbeddedViewer';
import { HomePage } from '~/components/Home/HomePage';
import { LandRouteSwitch } from '~/components/Land/LandRouteSwitch';
import { Layout } from '~/components/Layout';
import { MembershipRouteSwitch } from '~/components/Membership/MembershipRouteSwitch';
import { SellPopupPostMessage } from '~/components/Message/SellPopupPostMessage';
import { LanguageObserver } from '~/components/Observer/Language/LanguageObserver';
import { CookieConsent } from '~/components/Policy/Cookie';
import { useScrollRestoration } from '~/components/Route';
import { SupportRouteSwitch } from '~/components/Support';
export const RouteSwitch = () => {
  useScrollRestoration();

  return (
    <Switch>
      <Route>
        <Layout>
          <Switch>
            <Route exact path="/" component={HomePage} />
            <Route path="/membership" component={MembershipRouteSwitch} />
            <Route path="/adventure" component={AdventureRouteSwitch} />
            <Route path="/land" component={LandRouteSwitch} />
            <Route path="/support" component={SupportRouteSwitch} />
            <Route path="/challenge" component={ChallengeRouteSwitch} />
            <Redirect exact from="/bonus" to="/membership/item/citizen/levelup#myMission" />
            <Redirect exact from="/don/history" to="/membership/don/history" />
            <Redirect to="/" />
          </Switch>
          <CookieConsent />
          <EmbeddedViewer />
          <SellPopupPostMessage />
          <LanguageObserver />
        </Layout>
      </Route>
      <Redirect to="/" />
    </Switch>
  );
};
